export const lighterBlueColor = "dFd";
export const lighterGreenColor = "eFd";
export const lighterYellowColor = "fFd";
export const lighterOrangeColor = "gFd";
export const lighterRedColor = "hFd";
export const lighterPurpleColor = "iFd";
export default {lighterBlueColor,lighterGreenColor,lighterYellowColor,lighterOrangeColor,lighterRedColor,lighterPurpleColor};